<template>
  <div class="header-wrapper js-header">
  <section class="header">
    <div class="header-logo">
      <a href="/">
        <img src="../assets/images/logo-oab.png" alt="">
      </a>
    </div>
    <!-- /.header-logo -->

    <div class="header-title">
      <h1>
        Portal da Transparência OAB/RO
      </h1>
    </div>
    <!-- /.header-title -->

  </section>
    <!-- /.header -->

    <div class="header-offset"></div>
    <!-- /.header-offset -->
  </div>
  <!-- /.header-wrapper -->
</template>

<script>
  export default {
    name: 'Header'
  };
</script>

<style scoped lang="scss">
  .header {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 99;

    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    padding: 10px;

    text-align: center;

    background-color: #f2f2f2;
    background-image: url('../assets/images/background-header.png');
    border-top: 3px solid #b30200;

    box-shadow: 4px 0 20px -3px #333;
  }

  .header-offset {
    height: 77px;
  }

  .header-logo {
    flex: 0 0 100px;
  }

  .header-title {
    flex: 0 0 calc(100% - 110px);

    h1 {
      margin: 0;

      font-family: "Lato", sans-serif;
      font-size: 18px;
      font-weight: 700;
    }
  }

  a {
    display: inline-block;
  }

  img {
    width: 100%;
    height: auto;
  }

  @media (min-width: 420px) {
    .header {
      justify-content: center;
    }

    .header-offset {
      height: 87px;
    }

    .header-logo {
      flex: 0 0 120px;
    }

    .header-title {
      flex: 0 0 calc(100% - 120px);

      h1 {
        font-size: 22px;
      }
    }
  }

  @media (min-width: 1024px) {
    .header {
      height: 100px;
      justify-content: center;
    }

    .header-offset {
      height: 100px;
    }

    .header-logo {
      flex: 0 0 150px;
      margin-right: 20px;
    }

    .header-title {
      flex: 0 0 auto;

      h1 {
        font-size: 30px;
      }
    }
  }
</style>
